import { useEffect, useRef } from "react"
import { SquadupController } from "./squadup/squadup-controller"
import { SquadupEventName, SquadupEvents } from "./squadup/squadup-events"
import { useSnapshot } from "valtio"

export function useSquadup() {
  return SquadupController.getMain()
}

export function useSquadupSubscriber(handlers: {
  [key in keyof SquadupEvents]?: (data: SquadupEvents[key]) => void
}) {
  const squadup = useSquadup()
  const ref = useRef<Record<string, any>>(handlers)
  ref.current = handlers

  useEffect(() => {
    let disposers = []
    for (let key in handlers) {
      disposers.push(
        squadup.subscribe(key as SquadupEventName, (_name, data) => {
          ref.current[key]?.(data)
        }),
      )
    }
    return () => {
      for (let disposer of disposers) {
        disposer()
      }
    }
  }, [Object.keys(handlers).sort().join("")])
}

export function useSquadupState() {
  const squadup = useSquadup()
  return useSnapshot(squadup.state)
}
